@let current = selected();

<button
  type="button"
  (click)="dropdown.toggle()"
  aria-haspopup="listbox"
  [attr.aria-expanded]="dropdown.isOpen()"
  [attr.aria-label]="'Sort by ' + current.label"
  class="flex items-center gap-2 rounded-lg bg-white py-1.5 pl-3 pr-3 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-gray-200 transition-colors hover:bg-gray-50"
>
  <span class="text-gray-500">Sort:</span>
  <span class="truncate">{{ current.label }}</span>
  <app-icon name="chevron" class="h-4 w-4 text-gray-400 transition-transform" [class.rotate-180]="dropdown.isOpen()" />
</button>

@if (dropdown.isOpen()) {
  <div class="absolute right-0 z-30 mt-2 w-56 rounded-2xl bg-white p-1.5 shadow-xl ring-1 ring-gray-200">
    <ul
      cdkListbox
      [cdkListboxValue]="[value()]"
      (cdkListboxValueChange)="dropdown.choose($event, value)"
      aria-label="Sort customers by"
      class="focus:outline-none"
    >
      @for (option of options; track option.value) {
        @let active = option.value === current.value;
        <li
          [cdkOption]="option.value"
          [cdkOptionTypeaheadLabel]="option.label"
          class="flex cursor-pointer items-center gap-3 rounded-xl px-2.5 py-2 transition-colors hover:bg-gray-50 aria-selected:bg-blue-50/60 [&.cdk-option-active]:bg-gray-100"
        >
          <span class="min-w-0 flex-1 truncate text-sm" [class]="active ? 'font-semibold text-gray-900' : 'font-medium text-gray-800'">
            {{ option.label }}
          </span>
          @if (active) {
            <app-icon name="check" class="h-4 w-4 text-[#0A84FF]" />
          }
        </li>
      }
    </ul>
  </div>
}
